import { IFormViewForm } from 'components/FormView';

const OverchargeRfcForm: IFormViewForm = {
  id: 'OverchargeRfcForm',
  layout: {
    rows: 1,
    columns: 2,
  },
  fields: [
    {
      id: '1',
      type: 'PAPER_CONTAINER',
      visible: true,
      props: {
        name: 'activity',
        fullWidth: true,
        elevation: 0
      },
      position: {
        row: 1,
        col: 1
      },
      children: [
        {
          id: 1,
          type: 'TEXT_AREA',
          props: {
            label: '',
            name: 'NoticeMessage',
            fullWidth: true,
            style: {
              height: 200
            }
          },
        },
      ]
    }
  ]
};

export default OverchargeRfcForm;
